import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const KeyEnter = ({
  height = 16,
  width = 37,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 37 16" {...props}>
    <path
      d="M2.77151 16C1.85983 16 1.16999 15.772 0.701994 15.3159C0.233998 14.8597 0 14.1756 0 13.2634V2.74572C0 1.83352 0.233998 1.14937 0.701994 0.693273C1.16999 0.231091 1.85983 0 2.77151 0H34.2285C35.1462 0 35.8361 0.231091 36.298 0.693273C36.766 1.15545 37 1.8396 37 2.74572V13.2634C37 14.1695 36.766 14.8506 36.298 15.3067C35.8361 15.7689 35.1462 16 34.2285 16H2.77151ZM2.83533 14.4584H34.1647C34.5719 14.4584 34.8879 14.3489 35.1128 14.13C35.3377 13.9111 35.4501 13.5857 35.4501 13.1539V2.85519C35.4501 2.42341 35.3377 2.09806 35.1128 1.87913C34.8879 1.66021 34.5719 1.55074 34.1647 1.55074H2.83533C2.42203 1.55074 2.10598 1.66021 1.88718 1.87913C1.66838 2.09806 1.55897 2.42341 1.55897 2.85519V13.1539C1.55897 13.5857 1.66838 13.9111 1.88718 14.13C2.10598 14.3489 2.42203 14.4584 2.83533 14.4584Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.702 10.96H9.446V12.268H4.25V4H9.326V5.308H5.702V7.54H8.87V8.872H5.702V10.96Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.0157 6.52C15.4557 6.52 16.2597 7.492 16.2597 9.124V12.268H14.8677V9.22C14.8677 8.32 14.3277 7.84 13.7037 7.84C13.0677 7.84 12.2757 8.212 12.2757 9.292V12.268H10.8837V6.664H12.2757V7.552C12.5637 6.844 13.4397 6.52 14.0157 6.52Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M20.9583 6.664V7.768H19.7703V12.268H18.3783V7.768H17.3703V6.664H18.3783V4.6H19.7703V6.664H20.9583Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M27.4656 9.412C27.4656 9.568 27.4536 9.748 27.4416 9.952H23.0976C23.2536 10.732 23.8536 11.152 24.6936 11.152C25.2936 11.152 25.8816 10.888 26.2056 10.432L27.1416 11.14C26.6256 11.956 25.6296 12.412 24.6096 12.412C22.9416 12.412 21.6696 11.212 21.6696 9.46C21.6696 7.672 23.0016 6.52 24.6096 6.52C26.2056 6.52 27.4656 7.66 27.4656 9.412ZM23.0976 8.98H26.0856C26.0016 8.212 25.4016 7.756 24.6216 7.756C23.8776 7.756 23.2656 8.128 23.0976 8.98Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M31.8439 6.52C32.1799 6.52 32.5399 6.592 32.7559 6.712L32.4799 8.032C32.1559 7.864 31.8679 7.828 31.6639 7.828C30.7519 7.828 30.2479 8.74 30.2479 10.312V12.268H28.8439V6.664H30.2359V7.864C30.5359 6.928 31.1479 6.52 31.8439 6.52Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
